import React from 'react'

const ExeciseDetail = () => {
  return (
    <div>ExeciseDetail</div>
  )
}

export default ExeciseDetail